var map = {
	"./amazon.svg": "8306",
	"./discord.svg": "ec01",
	"./email.svg": "ba86",
	"./facebook.svg": "0bea",
	"./instagram.svg": "32fc",
	"./kwai.svg": "f3b3",
	"./linkedin.svg": "33b8",
	"./paypal.svg": "b3d7",
	"./pinterest.svg": "21d6",
	"./reddit.svg": "57c3",
	"./skype.svg": "382f",
	"./snapchat.svg": "1ec0",
	"./spotify.svg": "6d8f",
	"./telegram.svg": "44ea",
	"./threads.svg": "b420",
	"./tiktok.svg": "a35b",
	"./tinder.svg": "883a",
	"./twitch.svg": "c3e3",
	"./web.svg": "d9e6",
	"./whatsapp.svg": "1ffe",
	"./x.svg": "fcd3",
	"./youtube.svg": "346a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcf8";